import { formatDate, parseLocalDateString } from 'bernie-l10n';
import { ContextStore } from 'bernie-plugin-mobx';
import { ITimeFramesFormat, timeFramesList } from 'helpers/time-frames-list';

export interface IDateFormat {
  day: number;
  month: number;
  year: number;
}

export interface ITimeFormat {
  hour: number;
  minute: number;
  second: number;
}

export interface IFormatedDateTime {
  formattedPickupDate: IDateFormat;
  formattedDropDate: IDateFormat;
  formattedPickupTime: ITimeFormat;
  formattedDropTime: ITimeFormat;
}

export const formattedTimeString = (
  time: string,
  context: ContextStore,
  formatText: (key: string, ...args: any[]) => string
): string => {
  const timeFormatOption: ITimeFramesFormat = timeFramesList(context, formatText).find(
    option => option.value === time || '0' + option.value === time
  );

  return timeFormatOption ? timeFormatOption.label : '';
};

export const resolveDate = (date: string, localDateFormat: string): IDateFormat => {
  let dateObject = getDateObjectFromDateString(date, localDateFormat);
  dateObject = dateObject ? dateObject : new Date();
  if (dateObject) {
    return {
      day   : dateObject.getDate(),
      month : dateObject.getMonth() + 1,
      year  : dateObject.getFullYear()
    };
  }
};

//TODO: to fix it for AM/PM only
export const resolveTime = (time: string): ITimeFormat => {
  let hour: number;
  let minute: number;
  if (time) {
    hour = +time.substr(0, time.length - 4); // (-4 includes AM + Minutes)
    minute = +time.substr(-4, 2);
    if (time.includes('PM')) {
      if (hour !== 12) {
        hour = hour + 12;
      }
    } else {
      if (hour === 12) {
        hour = 0;
      }
    }
  }

  return {
    hour,
    minute,
    second : 0
  };
};

/*
 * Method to return a valid date object from a raw time string in either 24 hr format or 12 hr format handling trailing zeroes
 * Params: time input in string format
 * Returns: Date type object
 * */
export const parseTimeFromURL = (timeString): Date => {
  let hours;
  let minutes;
  let phase;
  let rawString = timeString;

  // check for single-digit hours and pad out
  if (rawString.length === 3 || rawString.length === 5) {
    rawString = '0' + rawString;
  }

  // try to parse into parts
  switch (rawString.length) {
  case 4:
    hours = parseInt(rawString.substring(0, 2), 10);
    minutes = parseInt(rawString.substring(2, 4), 10);
    break;
  case 6:
    hours = parseInt(rawString.substring(0, 2), 10);
    minutes = parseInt(rawString.substring(2, 4), 10);
    phase = rawString.substring(4, 6).toUpperCase();
    if (phase !== 'AM' && phase !== 'PM') {
      throw new Error('Failed to parse time value: ' + timeString);
    }
    break;
  default:
    throw new Error('Failed to parse time value: ' + timeString);
  }

  // check hours and minutes for correct integer parse
  if (isNaN(hours) || isNaN(minutes)) {
    throw new Error('Failed to parse time value: ' + timeString);
  }

  // adjust hours for phase (if there is one)
  if (hours === 12 && phase === 'AM') {
    hours = 0;
  }
  if (hours !== 12 && phase === 'PM') {
    hours += 12;
  }

  // check to make sure values are within bounds
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    throw new Error('Failed to parse time value: ' + timeString);
  }

  const date = new Date(0);
  date.setHours(hours);
  date.setMinutes(minutes);

  return date;
};

/*
 * Method to convert date obj to string in AM/PM format. Suitable for values. Cannot be used for localized content
 * params: Date object
 * Returns: Time String in AM/PM
 * */
export const formatTimeForTwelveHourFormat = dateObj => {
  let hours = dateObj.getHours();
  let phase = 'AM';

  if (hours === 12) {
    phase = 'PM';
  } else if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
    phase = 'PM';
  }

  const minutes = dateObj.getMinutes();

  const hoursString = hours + '';
  const minutesString = formatLeadingZeros(minutes + '', 2);

  return hoursString + minutesString + phase;
};

const formatLeadingZeros = (value, length) => {
  while (value.length < length) {
    value = '0' + value;
  }

  return value;
};

export function getDateObjectFromDateString(dateString: string, localDateFormat: string): Date {
  // TODO: to fix for locales specific
  let isoDateObj = parseLocalDateString(dateString, { raw : localDateFormat }) as Date;
  if (!isoDateObj) {
    isoDateObj = parseLocalDateString(dateString, { raw : 'yyyy-MM-dd' }) as Date;
  }

  return isoDateObj;
}

export function getIsoFormatDateFromDateString(dateString: string, localDateFormat: string): string {
  const todaysDate = new Date();

  const isoDateObj = getDateObjectFromDateString(dateString, localDateFormat);

  return isoDateObj ? formatDate(isoDateObj, { raw : 'yyyy-MM-dd' }) : formatDate(todaysDate, { raw : 'yyyy-MM-dd' });
}

export function getTodaysFormattedDate(localDateFormat: string): string {
  const todaysDate = new Date();

  return formatDate(todaysDate, { raw : localDateFormat });
}

export function getTommorwsDate(localDateFormat: string): string {
  const todaysDate = new Date();

  return formatDate(new Date(todaysDate.setDate(todaysDate.getDate() + 1)), { raw : localDateFormat });
}
